import React, { useState } from "react";
import view_icon from "../../assets/images/view_icon.svg";
import pdf_icon from "../../assets/images/pdf_icon.svg";
import cheque_icon from "../../assets/images/cheque_icon.svg";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import ProfileDetail from "../layout/ProfileDetail";

import { formatDate } from "../../utils/dateUtils";

import ReportModal from "../../components/popups/ReportModal";

const HistoryTable = ({ rows, type, role }) => {
  const navigate = useNavigate();

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [loadingReportId, setLoadingReportId] = useState(null);

  const [reportModal, setReportModal] = useState({
    open: false,
    type: "",
    companyId: null,
  });

  const openProfile = (item) => {
    setSelectedUserId(item.employeeId);
    setShowProfileModal(true);
  };

  return (
    <div className="custom_table_history table-responsive">
      <table className="table table-hover mb-0">
        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((row) => (
              <tr key={row.id} className="align-middle">
                {/* Name */}
                <td className="col-name">
                  <div
                    className="d-flex align-items-center cursor-pointer"
                    onClick={() => navigate(row.link)}
                  >
                    <div className="user_img me-2">
                      <img
                        src={row.image}
                        alt={row.name}
                        className="rounded-circle"
                      />
                    </div>

                    <span
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: row.name,
                      }}
                    />
                  </div>
                </td>

                {/* Email */}
                <td className="col-email text-muted">{row.email}</td>

                {/* Date Range */}
                <td className="text-muted text-nowrap">
                  {formatDate(row.payrollFrom)} to {formatDate(row.payrollTo)}
                </td>

                {/* Employee Count */}
                {role === "SuperAdmin" ? (
                  <td className="text-muted text-nowrap">
                    Employees - {row.employeeCount}
                  </td>
                ) : (
                  <td>{row.designation}</td>
                )}

                {/* Revenue */}
                <td className="fw-bold text-success text-nowrap">
                  {row.revenue}
                </td>

                {/* Payment */}
                <td className="text-nowrap">{row.payment}</td>

                {/* Actions */}
                <td className="text-end">
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    {/* View */}
                    <img
                      src={view_icon}
                      alt="view"
                      className="cursor-pointer"
                      onClick={() =>
                        role === "Client"
                          ? openProfile(row)
                          : navigate(row.link)
                      }
                      style={{
                        width: "18px",
                        height: "18px",
                      }}
                    />

                    {/* Tax Liability */}
                    {loadingReportId === `tax-${row.id}` ? (
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    ) : (
                      <img
                        src={pdf_icon}
                        alt="tax-report"
                        className="cursor-pointer"
                        onClick={() =>
                          setReportModal({
                            open: true,
                            type: "tax",
                            companyId: row.companyId,
                          })
                        }
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                        title="Tax Liability Report"
                      />
                    )}

                    {/* Payroll Summary */}
                    {loadingReportId === `summary-${row.id}` ? (
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    ) : (
                      <img
                        src={cheque_icon}
                        alt="summary-report"
                        className="cursor-pointer"
                        onClick={() =>
                          setReportModal({
                            open: true,
                            type: "summary",
                            companyId: row.companyId,
                          })
                        }
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                        title="Payroll Summary Report"
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-4">
                No history found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {selectedUserId && (
        <ProfileDetail
          show={showProfileModal}
          onClose={() => {
            setShowProfileModal(false);
            setSelectedUserId(null);
          }}
          type={type}
          clientId={selectedUserId}
        />
      )}

      <ReportModal
        show={reportModal.open}
        onClose={() =>
          setReportModal({
            open: false,
            type: "",
            companyId: null,
          })
        }
        reportType={reportModal.type}
        companyId={reportModal.companyId}
      />
    </div>
  );
};

export default HistoryTable;
